import { Paper, Typography } from "@material-ui/core";
import React from "react";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";

const RewardCard = ({ data, handleClick }) => {
	const types = {
		freeDelivery: "Envio Gratis",
		delivery: "",
		coupon: "Cupón de descuento",
		discount: "Platillo con descuento",
	};

	const amount = data.amount ? (
		<Typography variant="body2">
			{data.amount} $ <br />
		</Typography>
	) : null;

	const itemDetails = data.itemDetails ? (
		<Typography style={{ color: "#090909" }} variant="body2" component="p">
			Platillo: {data.itemDetails.name} <br />
			Precio: {data.itemDetails.price} $
			<br />
		</Typography>
	) : null;

	return (
		<Paper
			style={{
				margin: "0.5em",
				maxHeight: "300px",
				border: "pink 1px solid",
				padding: "1em 1em 0 1em",
				minWidth: "200px",
			}}
		>
			<Typography variant="h6" component="p">
				{data.name}
			</Typography>
			<Typography variant="body2" component="p">
				{types[data.type]}
			</Typography>
			{amount}
			{itemDetails}

			<ButtonWithStyle onClick={handleClick}>Eliminar</ButtonWithStyle>
		</Paper>
	);
};

export default RewardCard;
